// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { AWSProvider } from './aws-context';

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <AWSProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </AWSProvider>
  </React.StrictMode>
);

reportWebVitals();
